export const GET_TRUCKS = '/api/truck/by-run-id/{runId}';
export const UPDATE_PICKUP_TALLY = '/api/truck/{truckId}';
export const SET_TRUCK_COMPLETE = '/api/truck/{truckId}';
export const SET_RUN_DETAILS_COMPLETE = '/api/run/{runId}/{carrierId}/complete';
export const UPDATE_TRUCK_ROUTES = '/api/truck/map-update';
